import { ReactNode } from "react";

export const AuthHeader = ({
  header,
  text,
}: {
  header: string;
  text: ReactNode;
}) => {
  return (
    <section className="flex w-full flex-col gap-2 text-center">
      <p className="text-32 font-fraunces font-medium text-grey-950">
        {header}
      </p>
      <p className="text-sm text-grey-600">{text}</p>
    </section>
  );
};
